import type { CSSProperties, ReactNode } from "react";

type ContainerProps = {
  children: ReactNode;
  style?: CSSProperties;
  maxWidth?: number;
  pad?: number;
};

export function Container({ children, style, maxWidth = 1120, pad = 96 }: ContainerProps) {
  return (
    <div
      style={{
        maxWidth,
        margin: "0 auto",
        padding: `0 ${pad}px`,
        ...style,
      }}
    >
      {children}
    </div>
  );
}
